import { createAction } from 'typesafe-actions';
import { ProductEntries } from '../../../data/Product';

export const setSearchedProductState = createAction('@bs/SET_SEARCHED_PRODUCTS_STATE [DOC]', (searchedProductState: ProductEntries) => ({searchedProductState}))();

export const emptySearchedProductState = createAction('@bs/EMPTY_SEARCHED_PRODUCT_STATE [DOC]')();